import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const routes = [
    // {
    //     path: '/',
    //     redirect: '/index',

    // },
    // {
    //     path: '/index',
    //     name: 'index',
    //     component: () => import('@/view/index'),
    //     meta: {
    //         title: '审核登录',
    //         keepAlive: false
    //     }
    // },
    {
        path: '/changePassword',
        name: 'changePassword',
        component: () => import('@/view/changePassword'),
        meta: {
            title: '密码修改',
            keepAlive: false
        }
    },
    {
        path: '/findPassword',
        name: 'findPassword',
        component: () => import('@/view/findPassword'),
        meta: {
            title: '密码找回',
            keepAlive: false
        }
    },
    {
        path: '/myVisitorList/:id?',
        name: 'myVisitorList',
        component: () => import('@/view/myVisitorList'),
        meta: {
            title: '我的访客',
            keepAlive: false
        }
    },
    {
        path: '/approvalManage/:id?',
        name: 'approvalManage',
        component: () => import('@/view/approvalManage'),
        meta: {
            title: '审批管理',
            keepAlive: false
        }
    },
    {
        path: '/teacherInvita/:id?',
        name: 'teacherInvita',
        component: () => import('@/view/teacherInvita'),
        meta: {
            title: '邀约',
            keepAlive: false
        }
    },
    // 预约、邀约成功
    {
        path: '/bookInviteSuccess',
        name: 'bookInviteSuccess',
        component: () => import('@/view/bookInviteSuccess'),
        meta: {
            title: '访客预约',
            keepAlive: false
        }

    },
    // 邀约信息查询
    {
        path: '/searchInvite',
        name: 'searchInvite',
        component: () => import('@/view/searchInvite'),
        meta: {
            title: '预约首页',
            keepAlive: false
        }

    },
    // 访客预约
    {
        path: '/visitorBooking',
        name: 'visitorBooking',
        component: () => import('@/view/visitorBooking'),
        meta: {
            title: '访客预约',
            keepAlive: false
        }
    },
    // 人员照片录入
    // {
    //     path: '/photosPeople/:id?',
    //     name: 'photosPeople',
    //     component: () => import('@/view/photosPeople'),
    //     meta: {
    //         title: '人员照片录入',
    //         keepAlive: false
    //     }

    // },
    // 预约详情
    {
        path: '/bookDetail',
        name: 'bookDetail',
        component: () => import('@/view/bookDetail'),
        meta: {
            title: '预约详情',
            keepAlive: false
        }

    },
    // 预约详情
    {
        path: '/log',
        name: 'log',
        component: () => import('@/view/log'),
        meta: {
            title: '访客服务',
            keepAlive: false
        }
    },
    // 企业号导航按钮
    {
        path: '/logEnterprise',
        name: 'logEnterprise',
        component: () => import('@/view/logEnterprise'),
        meta: {
            title: '访客服务',
            keepAlive: false
        }
    },
     // 入校须知
     {
        path: '/inSchoolKnow',
        name: 'inSchoolKnow',
        component: () => import('@/view/inSchoolKnow'),
        meta: {
            title: '入校须知',
            keepAlive: false
        }
    },
    // 预约详情
    {
        path: '/register',
        name: 'register',
        component: () => import('@/view/register'),
        meta: {
            title: '访客注册',
            keepAlive: false
        }

    },
    // 审批管理单点登录
    {
        path: '/approvaSingleLogin',
        name: 'approvaSingleLogin',
        component: () => import('@/view/approvaSingleLogin'),
        meta: {
            title: '审核管理',
            keepAlive: false
        }

    },
    // 授权过期
    {
        path: '/codeHasUsed',
        name: 'codeHasUsed',
        component: () => import('@/view/codeHasUsed'),
        meta: {
            title: '授权过期',
            keepAlive: false
        }
    },

]

const router = new Router({ routes })

router.beforeEach((to, from, next) => {
    const title = to.meta && to.meta.title
    if (title) {
        document.title = title
    }
    next()
})

export { router }
